import * as React from 'react';
import { Field, getIn } from 'formik';

import {
  WizardSubmitButton,
  WizardPreviousButton
} from '@buyside/components/presentation/Form/Wizard/Wizard';
import PageHeader from '../../Helpers/pageHeader';
import PageFooter from '../../Helpers/PageFooter';
import Selectable from '@buyside/components/presentation/Selectable/selectable';
import Employed from './Employed';
import FileField from '@buyside/components/presentation/Form/Field/FileField/fileField';
import Unemployed from './Unemployed';
import Student from './Student';

import {
  InvestorEmploymentTypes,
  AllFormikProps
} from '@interfaces/userApplication/userApplication';
import { SelectableTypes } from '@interfaces/selectable/selectable';
import RecaptchaFailed from '../../Helpers/RecaptchaFailed';

import styles from '../pageStyles.scss';
const { employed, seekingEmployment, student } = InvestorEmploymentTypes;

type PickedFormikProps = Pick<
  AllFormikProps,
  'setFieldValue' | 'touched' | 'errors' | 'values' | 'setFieldError' | 'initialValues'
>;

export interface PESProps extends PickedFormikProps {
  isLoading: boolean;
  isRobot: boolean;
}

const ProEmploymentStatus: React.FunctionComponent<PESProps> = ({
  setFieldValue,
  touched,
  errors,
  values,
  isLoading,
  setFieldError,
  isRobot,
  initialValues
}): React.ReactElement => {
  const isTouched = getIn(touched, 'employmentStatus');
  const error = getIn(errors, 'employmentStatus');
  const { employmentStatus } = values;
  return (
    <>
      <PageHeader subHeader="What describes your current employment status?" />
      <div className={styles.inputForm}>
        <div className={styles.proEmploymentStatusOption}>
          <div className={styles.inputFieldThird}>
            <Selectable
              analyticsTag="application-employed"
              id="investorStatusIsEmployed"
              name="employmentStatus"
              onChange={(): void => {
                setFieldValue('employmentStatus', employed, false);
              }}
              selectableType={SelectableTypes.RADIO}
              checked={employmentStatus === employed}
            >
              <div className={styles.selectableTextCentered}>
                <p>Employed</p>
              </div>
            </Selectable>
          </div>
          <div className={styles.inputFieldThird}>
            <Selectable
              analyticsTag="application-unemployed"
              id="investorStatusIsUnemployed"
              name="employmentStatus"
              onChange={(): void => {
                setFieldValue('employmentStatus', seekingEmployment, false);
              }}
              selectableType={SelectableTypes.RADIO}
              checked={employmentStatus === seekingEmployment}
            >
              <div className={styles.selectableTextCentered}>
                <p>Unemployed</p>
              </div>
            </Selectable>
          </div>
          <div className={styles.inputFieldThird}>
            <Selectable
              analyticsTag="application-student"
              id="investorStatusIsStudent"
              name="employmentStatus"
              onChange={(): void => {
                setFieldValue('employmentStatus', student, false);
              }}
              selectableType={SelectableTypes.RADIO}
              checked={employmentStatus === student}
            >
              <div className={styles.selectableTextCentered}>
                <p>I'm a student</p>
              </div>
            </Selectable>
          </div>
          {isTouched && error && <div className={styles.fieldError}>{error}</div>}
        </div>
        {employmentStatus === employed && (
          <Employed
            setFieldValue={setFieldValue}
            touched={touched}
            errors={errors}
            setFieldError={setFieldError}
            values={values}
            initialValues={initialValues}
          />
        )}
        {employmentStatus === seekingEmployment && (
          <Unemployed
            setFieldValue={setFieldValue}
            setFieldError={setFieldError}
            initialValues={initialValues}
            values={values}
          />
        )}
        {employmentStatus === student && <Student setFieldValue={setFieldValue} />}
        <Field
          component={FileField}
          filefieldConfig={{ 'application/pdf': ['.pdf'] }}
          label="Resume (optional)"
          name="resume"
        />
        <br />
      </div>
      <WizardPreviousButton />
      <WizardSubmitButton
        submitText="Continue"
        analyticsTag="application-continue-pro-employment-status"
        isLoading={isLoading}
      />
      {isRobot && <RecaptchaFailed />}
      <PageFooter />
    </>
  );
};

export default ProEmploymentStatus;
